<!-- <app-topbar>
</app-topbar> -->

<app-header2></app-header2>



<main id="main" class="main-edu">
    <section class="education-services">
        <div class="container section" data-aos="fade-up">
            <div class="text-center my-2 section-title">
                <h3 data-aos="fade-up" data-aos-delay="100">Become a Pro Trader with
                    <span> HAWK </span>
                </h3>
                <br>

                <h6 class="m-auto">
                    Trade as a pro with HAWK. We will awake the Super Trader within you with proper guidance, education, Live market updates, financial news, and streaming services.
                </h6>

            </div>
            <div class="education bg-white">

                <div class="d-flex tab-header">
                    <div id="tab-btn-1" (click)="setTab1()" class="col-6 text-centerp-3 tab-btn tab-btn-start selected">BEGINNER</div>
                    <div id="tab-btn-2" (click)="setTab2()" class="col-6 text-centerp-3 tab-btn tab-btn-end">ADVANCE</div>
                </div>

                <div class="row p-5" style="display: flex; color:black" id="beginner">
                    <!-- <p>
                        We at HAWK are firm believers that <b>KNOWLEDGE IS THE BEST INVESTMENT</b> and teaching a person a useful skill can be more beneficial in the long run than filling a need for them temporarily. As the old saying goes, “Give a man a fish, and you feed him for a day. Teach a man to fish, and you feed him for a lifetime”.
                    </p>
                    <p>
                        <b>IT ALL STARTS WITH A FREE INTRODUCTORY CLASS.</b> Enjoy reading our free material and watch the video demos that will completely change your life. Welcome to the world of Stock Trading!
                    </p> -->




                    <div class="col-md-6 col-lg-4 d-flex mt-4">
                        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <h4 class="title"> Course Description </h4>
                            <p class="description">
                                HAWK Complete Foundation Stock Trading Course is designed for
                                Complete Beginners and Intermediate market participants.
                                We start off by covering basic concepts and work our way up to
                                more advanced level material. This unique course will cover the
                                real-world trading and examples. We focus on helping you learn to
                                develop your skill to trade in the financial markets.
                            </p>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4 d-flex mt-4">
                        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <h4 class="title"> Skill Levels </h4>
                            <p class="description">
                                All Levels from Beginner to Intermediate. You may have little to no experience with trading or investing, and that’s perfectly fine. Many people come to HAWK simply looking to develop their financial knowledge and improve their financial situation. HAWK helps people learn to take a more active and confident role in managing their own finances.
                            </p>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-4 d-flex mt-4">
                        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <h4 class="title"> Course Duration </h4>
                            <p class="description">
                                Total Number of Lectures: 20 Hours  + 5 Hours of Practical Learning + 5 Hours of Insights from Industry Experts and Professional Trader’s standpoint.
                            </p>
                        </div>
                    </div>

                    <div class="mt-5">
                        <h5>
                            What you’ll learn:
                        </h5>
                        <ul>
                            <li>
                                Completely understand how the stock market and trading world works, including the history of stock market, different exchanges (NYSE, NASDAQ & AMEX), and it’s evolution.
                            </li>
                            <li>
                                Know the process that a company goes through to become a Publicly Traded Company.
                            </li>
                            <li>
                                Finance concepts that any trader/ investor should know.
                            </li>
                            <li>
                                Valuation and master technical analysis: Candlestick Patterns, Chart Patters, Volume and Technical Indicators.
                            </li>
                            <li>
                                Filter out the noise, get to know what our traders use and how they think. Get insight from a professional trader's standpoint.
                            </li>
                            <li>
                                Different types of traders and trading strategies.
                            </li>
                            <li>
                                How to analyze and manage your own stock portfolio
                            </li>
                            <li>
                                Setting up a trading plan and strategies
                            </li>
                            <li>
                                Risk Management: how to reduce losses and manage overall portfolio risk.
                            </li>
                            <li>
                                Money Management: how to manage risk on each position, how many shares to buy, and where to take a loss.
                            </li>
                            <li>
                                How to short sell so you can make money if the market goes down.
                            </li>
                            <li>
                                Trading Psychology: become an Expert in human Emotions and the different Biases that affect people when Money is involved.
                            </li>
                            <li>
                                Trading Tools
                            </li>
                            <li>
                                How to pick a stockbroker and setting up your own stock broking account.
                            </li>
                        </ul>
                        This course has been crafted with care. I hope to see you inside, alongside the many happy students.
                    </div>

                    <div class="mt-5">
                        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <h4 class="title" > Final Word </h4>
                            <p class="description">
                                Your success as a professional trader depends on having sound theoretical knowledge coupled with practical understanding of the subject as well as the quality of information you have on the markets. Without these components, beating the market is next to impossible. The promise is that if you follow the system, you have a high probability of beating the market, not just to be an average trader who tries to survive
                                <br>
                                WE AT HAWK International DO NOT ASK YOUR MONEY AND GIVE FALSE PROMISES TO GIVE  YOU A RETURN.  WE GIVE YOU THE RIGHT KNOWLEDGE TO BE A SUCCESFUL TRADER SO THAT YOU DON’T HAVE TO DEPEND ON ANYONE AND FALL INTO ANY SCAMMERS OUT THERE. Anyone telling you that you can invest $500 and Make $5000 in a Short Time is just telling you what you want to hear. Don’t fall into those traps.

                                <br>
                                AT HAWK International, YOU WILL LEARN FROM THE BEST AND YOU HAVE CONTROL OF YOUR OWN MONEY.</p>
                        </div>
                    </div>
                    <h4 style="margin-top: 50px;">
                        <b class="mt-5">
                            <u>
                                Complete Foundation Stock Trading Course (Introductory Course Fee {{courseFee}} for the first 200 students - includes free introductory course on day trading)
                            </u>
                        </b>
                    </h4>



                    <!-- <div class="col-md-6 col-lg-4 d-flex">
                        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <h4 class="title"> Beginer Learning </h4>
                            <p class="description">We employ best p s to ensure that our students learn effectively and acquire the fundamental and technical skills for consistency in theirtrading.
                            </p>
                        </div>
                    </div> -->

                </div>

                <div class="row p-5" style="display: none;" id="advance">

                    <div class="col-md-12 col-lg-12 ">
                        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <h4 class="title"> Advance Learning </h4>
                            <p class="description">Course content will be available soon...
                                For more information contact HAWK Information Center...
                            </p>
                        </div>
                    </div>

                    <!-- <div class="col-md-6 col-lg-4 d-flex">
                        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                            <h4 class="title"> Advance Learning </h4>
                            <p class="description">We employ best people and invest in advanced and cutting-edge technologies to ensure that our students learn effectively and acquire the fundamental and technical skills for consistency in theirtrading.
                            </p>
                        </div>
                    </div> -->
                </div>

            </div>
        </div>
    </section>
</main>
